import { useEffect, useState } from "react";
import { Carousel } from "flowbite-react";
import { getTravPublicProfil } from "../../../services/callAPI/toProfil";
import UnvalidToast from "../../toasts/UnvalidToast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { badgeIcons } from "../../config/dictionnary/badges";

export function TravPublicModal({ pseudo }: { pseudo: string }) {
  const [openModal, setOpenModal] = useState(false);
  const [isFailure, setisFailure] = useState(false);

  const [profilR, setProfilR] = useState<{
    pseudo: string | undefined,
    presentation: string | null;
    trocNumber: number | undefined;
    comments: { content: string }[] | null;
    badges: string[];
  }>({
    pseudo: pseudo,
    presentation: "",
    trocNumber: undefined,
    comments: null,
    badges: []
  });

  const handleArrowClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  async function handleOnProfil(travPseudo: string) {
    try {
      const profilData = await getTravPublicProfil(travPseudo);

      //redefine profilR
      setProfilR({
        ...profilR,
        presentation: profilData.presentation,
        trocNumber: profilData.number_troc_done,
        comments: profilData.last3Comments,
        badges: profilData.badges
      });

      //open modal
      setOpenModal(true);

    } catch (error) {
      setisFailure(true);
    }
  }

  const closeModal = () => setOpenModal(false);

  useEffect(() => {
    // Désactiver le défilement quand la modal est ouverte
    if (openModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Nettoyage à la fermeture de la modal
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openModal]);

  return (
    <>
      {isFailure && <UnvalidToast message={`Profil de ${pseudo} indisponible`} onClose={() => setisFailure(false)} />}

      <button
        id="btn-profil-user"
        type="button"
        style={{ backgroundColor: 'rgba(224, 159, 62, 0.1)' }} // 10% opaque
        className="rounded-md py-1 px-4 hover:brightness-110 shadow-sm transition"
        onClick={() => handleOnProfil(pseudo)}
      >
        <span className="hover:underline font-semibold tracking-wide">{pseudo}</span>
      </button>

      {openModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
        >
          <div
            className="bg-white rounded-3xl w-full max-w-lg mx-4"
            onClick={handleArrowClick}
          >
            <div className="p-4 bg-gradient-to-r from-yellowCustom via-orangeCustom to-redCustom text-white rounded-t-3xl">
              <p className="text-center text-lg font-bold">Profil de {profilR.pseudo}</p>
            </div>

            <hr className="border-t-2 border-orangeCustom shadow" />

            {/* badges section */}
            {Array.isArray(profilR.badges) && profilR.badges.length > 0 && (
              <div className="flex flex-col items-center w-full mt-2">
                <h4 className="text-sm font-medium text-gray-700">Badges</h4>
                <div className="flex flex-wrap justify-center gap-2 mt-2">
                  {profilR.badges.map((badge, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-1 bg-orangeCustom text-lightRedCustom font-bold px-3 py-1 rounded-full text-xs shadow-sm"
                    >
                      <FontAwesomeIcon icon={badgeIcons[badge]} className="text-sm" />
                      <span>{badge}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Modal body */}
            <div className="flex flex-col gap-6 bg-white px-6 py-4 max-h-[400px] overflow-y-auto">
              <h2 className="text-lg font-semibold text-center text-greenCustom">Présentation</h2>

              {/* presentation section */}
              <div className="bg-yellowCustom border border-orangeCustom rounded-lg px-4 py-3 text-center shadow-sm">
                <p className="text-black font-medium">
                  {profilR.presentation
                    ? profilR.presentation
                    : "Cet utilisateur ne s'est pas encore présenté."}
                </p>
              </div>

              {/* troc done section */}
              <div className="flex justify-center">
                <div className="bg-orangeCustom text-white rounded-full px-5 py-2 font-semibold shadow-md">
                  {profilR.trocNumber || 0} trocs effectués
                </div>
              </div>

              {/* comments section */}
              <div>
                <h2 className="text-center text-greenCustom font-semibold">Commentaires</h2>

                <div id="caroussels-comments" className="h-12 w-auto mt-2">
                  <Carousel
                    slideInterval={5000}
                    indicators={true}
                    className="bg-gray-50 border px-6 py-4 text-center border-gray-300 rounded-xl shadow-inner"
                  >
                    {!profilR.comments || profilR.comments.length === 0 ? (
                      <p className="text-gray-500 italic">Aucun commentaire disponible</p>
                    ) : (
                      profilR.comments
                        .filter((comment) => comment.content !== null)
                        .map((comment, index) => (
                          <div key={index} className="flex h-full items-center justify-center w-full">
                            <p className="italic text-gray-700">"{comment.content}"</p>
                          </div>
                        ))
                    )}
                  </Carousel>
                </div>
              </div>
            </div>

            <hr className="border-t-2 border-orangeCustom shadow" />

            <div className="bg-white flex justify-center p-4 rounded-b-3xl">
              <button
                type="button"
                style={{ backgroundColor: '#540B0E' }}
                className="hover:bg-red-700 transition text-white font-semibold py-2 px-6 rounded-full shadow"
                onClick={closeModal}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
